/**
 * Onboarding Enums
 * These match the backend API enums
 */

/**
 * Factor types from backend API
 */
export enum FactorType {
  PUSH_NOTIFICATION = 'push_notification',
  PASSWORD = 'password',
  WHATSAPP_OTP = 'whatsapp_otp',
  SMS_OTP = 'sms_otp',
  TOTP = 'totp',
  WEBAUTHN = 'webauthn',
}

/**
 * Flow status from backend API
 */
export enum FlowStatus {
  IN_PROGRESS = 'in_progress',
  COMPLETED = 'completed',
  FAILED = 'failed',
}

/**
 * Challenge status from backend API
 */
export enum ChallengeStatus {
  PENDING = 'pending',
  APPROVED = 'approved',
  REJECTED = 'rejected',
  FAILED = 'failed',
  RETRY_REQUIRED = 'retry_required',
  IN_PROGRESS = 'in_progress',
}

/**
 * Token validation reason from backend API
 */
export enum TokenValidationReason {
  COMPLETED = 'completed',
  EXPIRED = 'expired',
  INVALIDATED = 'invalidated',
  INVALID_TOKEN = 'invalid_token',
}

/**
 * Frontend-only: current state of token validation flow
 */
export enum ValidationStatus {
  VALIDATING = 'validating',
  VALID = 'valid',
  ALREADY_COMPLETED = 'already-completed',
  EXPIRED = 'expired',
  INVALID = 'invalid',
}
